import React from 'react';
import { ReactComponent as DocIcon } from 'assets/icons/icon-document.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/icon-trash.svg';
import BankFactsheetUploader from './BankFactsheetUploader';
import { Banks, Bank_Factsheets } from 'graphql/schemaTypes.generated';
import { useDeleteBankFactsheetMutation } from 'graphql/mutations/RemoveBankFactsheet.generated';
import { useWrappedUrqlMutation } from 'toolbox';
import { toast } from 'react-toastify';
import { useFetchBankFactsheetsQuery } from './queries/GetBankFactsheets.generated';
import Bugsnag from '@bugsnag/js';

const BankFactsheets = ({ bank_id }) => {
  const [result, refreshFactsheets] = useFetchBankFactsheetsQuery({
    variables: { bank_id },
  });
  if (result?.error) Bugsnag.notify(result?.error);
  const bank_factsheets = result.data?.banks_by_pk?.bank_factsheets;

  const deleteBankFactsheet = useWrappedUrqlMutation(
    useDeleteBankFactsheetMutation,
    {
      onSuccess: () => {
        toast('Deleted factsheet successfully.');
        refreshFactsheets();
      },
      onError: (err) => {
        console.log(err);
        toast.error('Something went wrong. Could not delete factsheet.');
      },
    },
  );

  console.log(bank_factsheets);

  return (
    <div className="card">
      <div className="cardBody">
        <aside>
          <h2 className="mb-4 text-lg text-gray-800">Factsheets</h2>
          <h3 className="mb-4 text-base font-semibold text-gray-600">
            Upload a new Factsheet
          </h3>
          <BankFactsheetUploader bank_id={bank_id} className="mt-5" />
        </aside>
        <main>
          <div className="w-full h-full wrapper-fixed-height">
            {!result || bank_factsheets?.length < 1 ? (
              <div className="flex items-center justify-center h-full text-gray-500 select-none">
                No Factsheets
              </div>
            ) : (
              bank_factsheets?.map(
                ({ factsheetDate, upload }: Bank_Factsheets) => (
                  <div className="flex items-center w-full p-1 mb-3 rounded-lg cursor-pointer bg-jcap-100">
                    <DocIcon className="inline w-10 px-1 mr-1 pointer-events-none text-jcap-400" />
                    <div className="flex flex-col flex-grow pointer-events-none select-none">
                      <p className="text-sm font-semibold">{factsheetDate}</p>
                      <p className="text-xs text-gray-600">
                        PDF{' '}
                        <span className="text-gray-400">
                          {upload?.id?.split('-')[0]}
                        </span>
                      </p>
                    </div>
                    <TrashIcon
                      className="inline w-6 h-6 mr-1 text-red-400 hover:text-red-600"
                      onClick={() => {
                        deleteBankFactsheet.dispatch({ upload_id: upload?.id });
                      }}
                    />
                  </div>
                ),
              )
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default BankFactsheets;
